import { render, staticRenderFns } from "./ModalExpert.vue?vue&type=template&id=0dc435be&scoped=true"
import script from "./ModalExpert.vue?vue&type=script&lang=js"
export * from "./ModalExpert.vue?vue&type=script&lang=js"
import style0 from "./ModalExpert.vue?vue&type=style&index=0&id=0dc435be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc435be",
  null
  
)

export default component.exports